module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/3/3-8a4385df5eb33e073d87c3ca1d65a22a.jpg";